/* eslint-disable no-restricted-imports */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@material-ui/core';

export function ConfirmQnNumberDialog({
  qnDialogOpen,
  setQnDialogOpen,
  qnNumber,
  setQnNumber,
  handleConfirmWithQN,
}) {
  return (
    <Dialog open={qnDialogOpen} onClose={() => setQnDialogOpen(false)} maxWidth='sm' fullWidth>
      <DialogTitle>Confirmar Pedido</DialogTitle>
      <DialogContent>
        <Typography gutterBottom>
          Para confirmar o pedido, é necessário informar o número Q&N.
        </Typography>
        <TextField
          fullWidth
          label='Número Q&N *'
          variant='outlined'
          value={qnNumber}
          onChange={(e) => setQnNumber(e.target.value)}
          placeholder='Ex: QN-2025-001'
          style={{ marginTop: 16 }}
          helperText='Campo obrigatório'
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setQnDialogOpen(false)}>Cancelar</Button>
        <Button
          onClick={handleConfirmWithQN}
          color='primary'
          variant='contained'
          disabled={!qnNumber || qnNumber.trim() === ''}
        >
          Confirmar Pedido
        </Button>
      </DialogActions>
    </Dialog>
  );
}
